import ITranslationImages from "./ITransalationImages"
import BanksLogos from "../../images/paymentTypeLogo/banks-dk.png"

export const daImages: ITranslationImages = {
    images: {
        bankLogos: BanksLogos,
    },
}
